/**
 * NavButton - サイドバーナビゲーションボタン
 *
 * サイズ・フォント系は上位コンポーネントから props で受け取る。
 * デフォルト値は通常の使用に合わせた値を設定してある。
 *
 * @param {string} label          - ボタンラベル
 * @param {boolean} isActive      - 現在のページかどうか
 * @param {function} onClick      - クリックハンドラ
 * @param {string} paddingClass   - padding クラス (例: 'px-4 py-3')
 * @param {string} textSizeClass  - font-size クラス (例: 'text-sm')
 */
function NavButton({
  label,
  isActive,
  onClick,
  paddingClass = "px-4 py-3",
  textSizeClass = "text-sm",
}) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-center transition-colors cursor-pointer my-2 ${paddingClass} ${textSizeClass} ${
        isActive
          ? "text-blue-600 font-semibold"
          : "text-gray-600 hover:text-gray-900"
      }`}
    >
      {label}
    </button>
  );
}

export default NavButton;
